function SvgLoanCRM(props) {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.66667 9C7.03333 9 7.34722 8.86944 7.60833 8.60833C7.86944 8.34722 8 8.03333 8 7.66667C8 7.3 7.86944 6.98611 7.60833 6.725C7.34722 6.46389 7.03333 6.33333 6.66667 6.33333C6.3 6.33333 5.98611 6.46389 5.725 6.725C5.46389 6.98611 5.33333 7.3 5.33333 7.66667C5.33333 8.03333 5.46389 8.34722 5.725 8.60833C5.98611 8.86944 6.3 9 6.66667 9ZM1.33333 12.6667C0.966667 12.6667 0.652778 12.5361 0.391667 12.275C0.130556 12.0139 0 11.7 0 11.3333V4C0 3.63333 0.130556 3.31944 0.391667 3.05833C0.652778 2.79722 0.966667 2.66667 1.33333 2.66667H4V1.33333C4 0.966667 4.13056 0.652778 4.39167 0.391667C4.65278 0.130556 4.96667 0 5.33333 0H8C8.36667 0 8.68056 0.130556 8.94167 0.391667C9.20278 0.652778 9.33333 0.966667 9.33333 1.33333V2.66667H12C12.3667 2.66667 12.6806 2.79722 12.9417 3.05833C13.2028 3.31944 13.3333 3.63333 13.3333 4V11.3333C13.3333 11.7 13.2028 12.0139 12.9417 12.275C12.6806 12.5361 12.3667 12.6667 12 12.6667H1.33333ZM1.33333 11.3333H12V4H1.33333V11.3333ZM5.33333 2.66667H8V1.33333H5.33333V2.66667Z"
        fill="white"
      />
    </svg>
  );
}

export default SvgLoanCRM;
